import { DebugLogger } from 'lib/debugLogger';
import { features } from 'reactApp/mail-features';

// CLOUDWEB-19554
// Обновленные коммуникации оверквотников
export const overquotaNewCommunication = features.has('overquota-new-communication');

export const defaultOverquotaMoreInfoUrl = overquotaNewCommunication
    ? 'https://help.mail.ru/cloud_web/files/overflowing/'
    : 'https://help.mail.ru/legal/terms/cloud/la/';

export const overquotaMoreInfoUrl = features.getAsURL('overquota-more-info-url', defaultOverquotaMoreInfoUrl);

export const overquotaCommunicationsClearButton = features.has('overquota-communications-clear-button');

interface OverquotaModalConfig {
    // фича включена?
    enabled: boolean;
    // показывать кнопку очистки
    clearButton: boolean;
}
export const overquotaModalConfig: OverquotaModalConfig = features.getAsJSONWithDefaults('overquota-modal-config', {
    enabled: true,
    clearButton: overquotaCommunicationsClearButton,
} as OverquotaModalConfig);

interface OverquotaModalViewerConfig {
    // показывать кнопку очистки
    clearButton: boolean;
}
export const overquotaModalViewerConfig: OverquotaModalViewerConfig = features.getAsJSONWithDefaults('overquota-modal-viewer-config', {
    clearButton: overquotaCommunicationsClearButton,
} as OverquotaModalViewerConfig);

interface OverquotaDisabledFeaturesModal {
    // показывать кнопку очистки
    clearButton: boolean;
}
export const overquotaDisabledFeaturesModalConfig: OverquotaDisabledFeaturesModal = features.getAsJSONWithDefaults(
    'overquota-disabled-features-modal-config',
    {
        clearButton: overquotaCommunicationsClearButton,
    } as OverquotaDisabledFeaturesModal
);

interface OverquotaFileLoadConfig {
    // показывать кнопку очистки
    clearButton: boolean;
}
export const overquotaFileLoadConfig: OverquotaFileLoadConfig = features.getAsJSONWithDefaults('overquota-file-load-config', {
    clearButton: overquotaCommunicationsClearButton,
} as OverquotaFileLoadConfig);

interface OverquotaBannerConfig {
    // включена ли фича
    enabled: boolean;
    // тип второй кнопки
    secondaryButton: 'clear' | 'help' | 'none';
    // Ссылка на хелп для второй кнопки типа 'help'
    helpLink: string;
}
export const overquotaBannerConfig: OverquotaBannerConfig = features.getAsJSONWithDefaults('overquota-banner-config', {
    enabled: true,
    secondaryButton: overquotaNewCommunication ? 'help' : 'none',
    helpLink: defaultOverquotaMoreInfoUrl,
} as OverquotaBannerConfig);

/**
 * CLOUDWEB-20569: параметр для эксперимента бэка
 */
export const overquotaBackendEnabled = features.has('parameter-for-backend-exp');

interface OverquotaFoldersConfig {
    // включена ли фича
    enabled: boolean;
    // показывать кнопку очистки
    clearButton: boolean;
    // количество папок в плашке
    count: number;
    // url который открывается по клику на папку "Почта"
    url: string;
}
// cloudweb-19905
export const overquotaFoldersConfig: OverquotaFoldersConfig = features.getAsJSONWithDefaults('overquota-folders-config', {
    enabled: false,
    clearButton: overquotaCommunicationsClearButton,
    count: 4,
    url: 'https://e.mail.ru',
} as OverquotaFoldersConfig);

interface OverquotaPaywallConfig {
    // набор тарифов
    // https://onlineconf.mail.ru/#/cloud/services/cloud-web/features/tariff-buy-disable-ads-tariff-ids
    tariffs: number;
    // выбранный тариф (m/y)
    activeTab: string;
    // заголовок окна пейвола
    title: string;
    // заголовок окна покупки конкретного тарифа
    paymentTitle: string;
}

export const overquotaPaywallConfig: OverquotaPaywallConfig = features.getAsJSONWithDefaults('overquota-paywall-config', {
    tariffs: 51,
    activeTab: 'y',
    title: 'Облако без ограничений с подпиской Mail Space',
    paymentTitle: 'Снятие ограничений с подпиской Mail Space',
} as OverquotaPaywallConfig);

export const disableAdsIframeSendHashAnalytics = features.has('disable-ads-iframe-send-hash-analytics');

export const buyDisableAdsDebug = features.has('buy-disable-ads-debug');

export const disableAdsLogger = new DebugLogger({ DEBUG_SCOPE: 'DisableAds', DEBUG: buyDisableAdsDebug });

// куда отправлять по кнопке покупки в коммуникациях
export const overquotaCommunicationPayPlacement = features.getAsString('overquota-communication-pay-placement', 'landing') as
    | 'paywall'
    | 'landing';
